import { format } from 'bv-helpers/price';

export default (fractionalPrice) => (
  format(fractionalPrice) || 'SP'
);
